export default {
    menu: {
        home: 'Home',
        contact: 'Contact',
        offer: 'Offer'
    },
    home: {
        intro: {
            firstTitle: 'PHU Miron Company',
            secondTitle: 'Used yachts for sale',
            subtitle: 'Wide choice of motor yachts, engines and transmissions.',
            offerLink: 'See our offer'
        },
        about: {
            title: '20 years on the market.<br>Hundreds of satisfied customers.',
            content: {
                part1: `
Our company deals with used motor yachts, engines and transmissions.
<br>We are characterized by precise choice of yachts we buy and great care in their restoration.
<br>All of that so that our customers can enjoy high quality at a low price.`,
                part2: 'We can offer a wide choice of motor yachts, such as:',
                list: [
                    'displacement and sliding yachts,',
                    'cabin and non-cabin (open) yachts,',
                    'racing yachts (sliders), sports and tourist yachts,',
                    'yachts with stationary engines and outboard motors.'
                ],
                summary: `
In addition, we import boat engines (stationary or outboard), transmissions,
as well as various types of mechanical equipment: pumps, transoms and others.`
            }
        },
        contact: {
            title: 'Contact us',
            phone: {
                title: 'Phone',
                description: 'Call us and get more information.'
            },
            email: {
                title: 'Email',
                description: 'Don\'t have a time for calling?<br>Send us an email!'
            },
            address: {
                title: 'Address',
                description: 'Szałkowo 28A<br>14-200 Iława<br>Poland',
                linkLabel: 'See us on the map'
            }
        }
    },
    offer: {
        title: 'Our current offer',
        archive: {
            title: 'Archive',
            details: 'Details',
            goToArchive: 'See the whole archive'
        }
    },
    archive: {
        title: 'Archive',
        pagedTitle: 'Page {pageNumber} of Archive',
        goToOffer: 'Go to current offer',
        paging: {
            next: 'Next',
            prev: 'Previous',
            pageInfo: 'Page {pageNumber} of {totalPages}'
        },
        details: {
            title: 'Archive',
            sold: 'Sold'
        },
        loading: 'Loading'
    },
    item: {
        priceType: {
            INCLUDING_VAT: 'incl. VAT',
            EXCLUDING_VAT: 'excl. VAT',
            FREE_OF_VAT: 'free of VAT'
        }
    },
    stickyOfferLink: {
        label: 'See our current offer'
    },
    notFound: {
        subtitle: 'We couldn\'t find page that you\'re looking for.',
        goBack: 'Go back',
        goToHome: 'Go To Home'
    }
};
